module.exports = __webpack_public_path__ + "img/fond-calcul-litteral.6536a94b.png";